import {
  extractPaymentAttachmentValues,
  isPaymentAttachmentField
} from '../../helpers/paymentAttachmentCodes'

export const buildOrderSummaryFields = (orderDetails) => {
  if (!orderDetails) return []

  return [
    {
      label: 'Número de pedido',
      value: orderDetails.order_db_ref || '-'
    },
    {
      label: 'Fecha de entrega',
      value: orderDetails.delivery_date || '-'
    },
    {
      label: 'Dirección de entrega',
      value: orderDetails.delivery_address || 'N/A'
    },
    {
      label: 'Comentarios generales',
      value: orderDetails.comments || '-'
    }
  ]
}

export const buildOrderFields = (orderDetails, customFields = []) => {
  const summaryLabels = new Set(
    buildOrderSummaryFields(orderDetails).map(({ label }) => label?.trim()?.toLowerCase())
  )

  if (!customFields?.length) return []

  return customFields.reduce((acc, field) => {
    if (!field || isPaymentAttachmentField(field)) return acc

    const { label, value } = field
    const nextLabel = label || '-'
    if (summaryLabels.has(nextLabel?.trim()?.toLowerCase())) return acc

    acc.push({
      label: nextLabel,
      value: value || '-'
    })

    return acc
  }, [])
}

export const getOrderPaymentAttachmentValues = (customFields = []) => {
  return extractPaymentAttachmentValues(customFields)
}
